import { useEffect, useState } from "react";
import BreadcrumbsComponent from "../../components/Breadcrumbs/BreadcrumbsComponent";
import { ContentCard } from "../../components/CardPortafolio/CardPortafolio";
import TableInvestments from "../../components/TableInvestments/TableInvestments";
import { fundInvestment, getFunds } from "../../services/fundService";
import "./PageInvestments.css";
import { useNavigate } from "react-router-dom";

export default function PageInvestments() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const depositar = () => {
    navigate("/recarga-tu-cuenta");
  };

  const retirar = () => {
    navigate("/solicitud-de-retiro");
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [inversiones, fondos] = await Promise.all([
          fundInvestment(),
          getFunds(),
        ]);

        const inversionesCompletas = inversiones.map((inv) => {
          const fondo = fondos.find((f) => f.id === inv.fund);
          return {
            ...inv,
            fondoInfo: fondo || {},
          };
        });
        setData(inversionesCompletas);
      } catch (error) {
        console.error("Error cargando inversiones o fondos:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="page-investments container-animated">
      <div className="row justify-content-between aling-items-center">
        <div className="col-4">
          <BreadcrumbsComponent />
        </div>
        <div className="col-4 d-flex justify-content-end align-items-center">
          <div className="mr-3 wallet-link" onClick={() => depositar()}>
            Depositar
          </div>
          <div className="wallet-link" onClick={() => retirar()}>
            Retirar
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12 mb-4">
          <div className="card-container">
            <div style={{ width: "100%" }}>
              <ContentCard valorActivo={data} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-lg-12">
          <div className="grid-scroll-h-content border-radius">
            <div className="responsive-table">
              <TableInvestments mas />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
